import { useState, useEffect } from 'react';
import { Owners, UserResponse } from '../models/User';
import { getUsers } from '../helpers/user';

const useActiveUsers = () => {
  const [owners, setOwners] = useState<Owners[]>([]);
  const [loading, setLoading] = useState(false);

  const getOwners = () => {
    setLoading(true);
    getUsers()
      .then(res => {
        const resp = res.map(item => {
          const userResp = item as UserResponse;
          return {
            id: item.id,
            username:
              userResp.first_name !== ''
                ? `${userResp.first_name} ${userResp.last_name}`
                : userResp.username,
          };
        });
        setOwners(resp);
      })
      .catch(err => setOwners([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getOwners();
  }, []);

  return { owners, loading };
};

export default useActiveUsers;
